var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscVertical2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 461,
    viewBox: "0 0 146 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.84985 387.963C9.84985 422.778 38.0537 451 72.8448 451C107.636 451 135.84 422.778 135.84 387.963L135.84 72.4904C135.84 37.6763 107.636 9.45383 72.8448 9.45383C38.0537 9.45383 9.84985 37.6763 9.84985 72.4904L9.84985 387.963Z",
    stroke: "url(#paint0_linear_55_2032)",
    strokeWidth: 18.61,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_2032",
    x1: 72.8398,
    y1: 0.138456,
    x2: 72.8398,
    y2: 460.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AD7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#28AD7E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscVertical2);
export default __webpack_public_path__ + "static/media/miscVertical2.33cb911c13855947ad076bf844809ba2.svg";
export { ForwardRef as ReactComponent };